import conf from './config'
import rest from "./rest.js"

export default {
  ...conf,
  ...rest
}
